import { UploadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useSelector } from 'react-redux'
import { testRunState } from '../../../../redux/testRun/testRunList.slice'
import SkeletonBasicDetails from './SkeletonBasicDetails'
import TestRunTabs, {
    resolveTestRunProjectId,
} from '../../../shared/TestRunTabs'
import styles from '../../../../testrun.module.css'

const BasicDetails = ({ setOpen = () => { }, projectId: projectIdProp }) => {
    const { testRunDetail: testRunDetailData, testRunDetailLoading } =
        useSelector(testRunState)
    const projectId = resolveTestRunProjectId(
        projectIdProp ||
        testRunDetailData?.filters?.project?._id ||
        testRunDetailData?.filters?.project
    )

    if (testRunDetailLoading) {
        return <SkeletonBasicDetails />
    }

    return (
        <div className={styles.detailHeader}>
            <TestRunTabs
                projectId={projectId}
                activeTab="detail"
                reportName={testRunDetailData?.name || 'Report Details'}
            />

            <div className={styles.sectionHeader}>
                <div className={styles.pageHeaderText}>
                    {/* <p className={styles.pageEyebrow}>Test Report</p> */}
                    <h2 className={styles.pageTitle}>
                        {testRunDetailData?.name || 'Report Details'}
                    </h2>
                </div>

                <div className={styles.toolbarActions}>
                    <Button
                        className={styles.secondaryButton}
                        onClick={() => setOpen(true)}
                        icon={<UploadOutlined />}
                    >
                        Export Report
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default BasicDetails
